import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from "../../../layout/default";
import { Dropdown, DropdownButton, Button, Row, Col, Card, Spinner, Table } from 'react-bootstrap';
import Select from 'react-select';
import Block from "../../../components/Block/Block";
import { Link } from "react-router-dom";

const SupplierDashboard = ({ userId }) => {
    const [orderItems, setOrderItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null); // Changed to single category
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch categories on mount
    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        axios
            .get(`${process.env.REACT_APP_HOST}api/category`, {
                headers: { Authorization: `Bearer ${authToken}` },
            })
            .then((response) => {
                if (response.data.success) {
                    setCategories(response.data.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching categories:', error);
                setError('Failed to fetch categories');
            });
    }, []);

    // Fetch orders based on filters
    const fetchOrders = () => {
        const authToken = localStorage.getItem('authToken');
        setLoading(true);
        const params = {
            user_id: userId,
            order_status: selectedStatuses.map(status => status.value), // map to selected status values
            category_id: selectedCategory ? selectedCategory.id : null, // map to selected category value (single)
        };

        axios
            .get(`${process.env.REACT_APP_HOST}api/orders/get-supplier-orders`, {
                headers: { Authorization: `Bearer ${authToken}` },
                params: params,
            })
            .then((response) => {
                setOrderItems(response.data);
            })
            .catch((error) => {
                console.error('Error fetching order items:', error);
                setError('Failed to fetch order items');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Order status options for select dropdown
    const statusOptions = [
        { value: '0', label: 'ORDERED' },
        { value: '1', label: 'DISPATCHED' },
        { value: '2', label: 'DELIVERED' },
        { value: '3', label: 'CANCELLED' },
    ];

    // Handle status change
    const handleStatusChange = (selected) => {
        setSelectedStatuses(selected);
    };

    // Handle category change
    const handleCategoryChange = (category) => {
        setSelectedCategory(category); // single category selection
    };

    return (
        <Layout title="Supplier Dashboard">
            <Block.HeadContent>
                <ul className="d-flex">
                    <li>
                        <Link
                            to="/shop/auths/supplier-panel"
                            className="btn btn-primary btn-md d-md-none"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/shop/auths/supplier-panel"
                            className="btn btn-primary d-none d-md-inline-flex"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                </ul>
            </Block.HeadContent>
            <div className="container mt-4">
                <Card className="mb-4 shadow-sm">
                    <Card.Body>
                        <Card.Title className="text-center mb-4">
                            Supplier Dashboard
                        </Card.Title>
                        <Row className="justify-content-center mb-3">
                            <Col xs="auto">
                                <Select
                                    isMulti
                                    options={statusOptions}
                                    value={selectedStatuses}
                                    onChange={handleStatusChange}
                                    placeholder="Select Order Status"
                                    className="mb-2"
                                />
                            </Col>
                            <Col xs="auto">
                                <DropdownButton
                                    id="dropdown-category"
                                    title={selectedCategory ? `Category: ${selectedCategory.title}` : 'Select Category'}
                                    variant="info"
                                    className="mb-2"
                                    drop="down"
                                    onSelect={(categoryId) => {
                                        const category = categories.find((cat) => cat.id === parseInt(categoryId));
                                        handleCategoryChange(category);
                                    }}
                                >
                                    <Dropdown.Item as="button" eventKey="">
                                        All Categories
                                    </Dropdown.Item>
                                    {categories.map((category) => (
                                        <Dropdown.Item key={category.id} as="button" eventKey={category.id}>
                                            {category.title}
                                        </Dropdown.Item>
                                    ))}
                                </DropdownButton>
                            </Col>
                            <Col xs="auto">
                                <Button variant="primary" onClick={fetchOrders}>
                                    Go
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Row>
                    {loading ? (
                        <div className="text-center w-100">
                            <Spinner animation="border" variant="primary" />
                            <p>Loading...</p>
                        </div>
                    ) : error ? (
                        <p className="text-danger w-100 text-center">{error}</p>
                    ) : orderItems.length > 0 ? (
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Quantity</th>
                                    <th>Unit Quantity</th>
                                    <th>Unit</th>
                                    <th>Category</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderItems.map((item) => (
                                    <tr key={item.product_variant_id}>
                                        <td>{item.product_title}</td>
                                        <td>{item.total_quantity}</td>
                                        <td>{item.Unit_Quantity}</td>
                                        <td>{item.Unit_title}</td>
                                        <td>{categories.find((cat) => cat.id === item.category_id)?.title || 'Unknown'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="text-center w-100">No orders found.</p>
                    )}
                </Row>
            </div>
        </Layout>
    );
};

export default SupplierDashboard;
